<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>The Reconstruction Amendments</h1>
<h1 class="bk1">The Essential Documents / Volume 2</h1>
<p class="bkau">Edited by Kurt T. Lash</p>
<p class="bkpub">The University of Chicago Press     Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lash-vol2-0003.vue?8607ea96